import { gql } from '@apollo/client';

export const DELETE_INDICATOR_FRAMEWORK = gql`
  mutation deleteIndicatorFramework($id: ID!) {
    deleteIndicatorWorkspace(id: $id) {
      id
    }
  }
`;
